import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { setConstraints } from '../../store/birdLayout/BirdLayoutState';
import { selectBirdJobContentState, selectAccessibilityLabelState, } from '../../store/selectors';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
export const BirdJobContentBase = function ({ id, actions, host, iframeSandbox, state, accessibilityLabel, }) {
    const { jobResultsUri, jobResultsContentSrc, jobResultsContentSrcDoc } = state;
    const minSize = 100;
    useLayoutEffect(() => {
        actions.setConstraints(id, {
            minWidth: minSize,
            minHeight: minSize,
        });
    }, [actions, id]);
    if (!jobResultsContentSrc && !jobResultsContentSrcDoc && (!host || !jobResultsUri)) {
        return null;
    }
    // If jobResultsContentSrcDoc is provided, use that as the iframe srcDoc, keeping src undefined.
    // Otherwise, use jobResultsContentSrc if provided, then fall back to host+jobResultUri.
    const iframeSrc = jobResultsContentSrcDoc
        ? undefined
        : jobResultsContentSrc || `${host}${jobResultsUri}`;
    return (_jsx("iframe", { style: {
            borderWidth: 0,
            flexGrow: 1,
            flexShrink: 0,
            minWidth: minSize + 'px',
            minHeight: minSize + 'px',
        }, srcDoc: jobResultsContentSrcDoc, src: iframeSrc, sandbox: iframeSandbox || 'allow-presentation allow-scripts allow-same-origin allow-forms', "aria-label": accessibilityLabel }));
};
export const BirdJobContent = connect((state, props) => ({
    state: selectBirdJobContentState(state, props.id),
    host: state.transport.serverHost,
    iframeSandbox: state.transport.iframeSandbox,
    accessibilityLabel: selectAccessibilityLabelState(state, props.id),
}), (dispatch) => ({
    actions: bindActionCreators({ setConstraints }, dispatch),
}))(BirdJobContentBase);
